import React from 'react';
import RefreshDataPanel from '@/components/RefreshDataPanel';

const RefreshDataPage: React.FC = () => {
  return (
    <>
      <div className="content-toolbar m-5">
        <button
          className="bg-rs-jet border border-rs-off-white/10 hover:bg-rs-jet-light text-rs-off-white py-3 px-6 rounded flex items-center"
          onClick={() => (window.location.href = "/dashboard")}
        >
          <span className="material-symbols-outlined">arrow_back_ios</span>
          Back to Landing Page
        </button>
      </div>
      <div className="container mx-auto py-8">
        <RefreshDataPanel />
      </div>
    </>
  );
};

export default RefreshDataPage;

